module.exports = __webpack_public_path__ + "static/media/avatar.1c0cd2a0.png";